var e=class extends Error{constructor(n){super(n),this.name="AuthError"}},o=new e("Token is unavailable"),s=new e("Invalid session"),t=new e("Unimplemented");export{o as a,s as b,t as c};
